import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Footer from '../components/footer/Footer';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black">
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* <button
          onClick={() => navigate('/')}
          className="flex items-center gap-2 text-green-400 hover:text-green-300 mb-6 transition-all duration-300 group"
        >
          <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
          Back to Home
        </button> */}

        <div className="bg-gradient-to-br from-white/10 to-white/5 rounded-3xl shadow-2xl p-8 backdrop-blur-xl border border-white/20">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-white via-green-200 to-orange-300 bg-clip-text text-transparent mb-6">
            Terms and Conditions
          </h1>

          <div className="text-gray-200 space-y-6">
            <section>
              <h2 className="text-2xl font-semibold text-white mb-3">1. Acceptance of Terms</h2>
              <p className="leading-relaxed break-words overflow-hidden">
                By accessing and using Kaha's services, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use the platform.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-3">2. Description of Service</h2>
              <p className="leading-relaxed break-words overflow-hidden">
                Kaha provides a platform for users to discover businesses, locations, and related information. We reserve the right to modify or discontinue services at any time.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-3">3. Use License</h2>
              <p className="leading-relaxed break-words overflow-hidden">
                Permission is granted to temporarily access materials on Kaha's platform for personal, non-commercial use only. This is a license, not a transfer of ownership.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-3">4. User Responsibilities</h2>
              <p className="leading-relaxed break-words overflow-hidden">
                You are responsible for maintaining the confidentiality of your account and for all activities under your account. You agree to provide accurate and up-to-date information.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-3">5. Prohibited Activities</h2>
              <p className="leading-relaxed break-words overflow-hidden">
                Users must not:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Post false or misleading information</li>
                <li>Upload harmful, illegal, or offensive content</li>
                <li>Attempt to gain unauthorized access to the system</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-3">6. Intellectual Property</h2>
              <p className="leading-relaxed break-words overflow-hidden">
                All content, trademarks, and materials on Kaha are owned by or licensed to us. Unauthorized use is prohibited.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-3">7. Limitation of Liability</h2>
              <p className="leading-relaxed break-words overflow-hidden">
                Kaha is not liable for any direct, indirect, or incidental damages arising from the use or inability to use the platform.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-3">8. Termination</h2>
              <p className="leading-relaxed break-words overflow-hidden">
                We reserve the right to suspend or terminate accounts that violate these terms without prior notice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-3">9. Privacy Policy</h2>
              <p className="leading-relaxed break-words overflow-hidden">
                Your use of Kaha is also governed by our Privacy Policy.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-3">10. Governing Law</h2>
              <p className="leading-relaxed break-words overflow-hidden">
                These terms shall be governed by the laws of Nepal.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mb-3">11. Contact</h2>
              <p className="leading-relaxed break-words overflow-hidden">
                For any questions, contact us at: +977 9801138780
              </p>
            </section>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default TermsAndConditions;
